import React, {Component} from 'react'
import {Modal, Form, Input, Upload, Button} from 'antd'

class AreaModifyModal extends Component {

    handleAdd = () => {
        const {handleAdd, form} = this.props
        form.validateFields((err, fieldsValue) => {
            if (!err) {
                handleAdd(fieldsValue)
            }
        })
    };

    render() {
        const {handleCancel, record, form, ...restForm} = this.props;
        const {getFieldDecorator} = form;
        return (
            <Modal onOk={this.handleAdd}
                   onCancel={handleCancel}
                   afterClose={() => form.resetFields()}
                   {...restForm}>
                <Form.Item>
                    {getFieldDecorator('id', {
                        initialValue: record.id
                    })(
                        <Input style={{display: 'none'}}/>
                    )}
                </Form.Item>
                <Form.Item label={'名称'}>
                    {getFieldDecorator('name', {
                        rules: [{required: true, message: '请输入名称'}],
                        initialValue: record.name
                    })(
                        <Input/>
                    )}
                </Form.Item>
                <Form.Item label={'图片'}>
                    {getFieldDecorator('image')(
                        <Upload beforeUpload={file=>{
                            form.setFieldsValue({image:file})
                            return false
                        }}>
                            <Button>点击上传</Button>
                        </Upload>
                    )}
                </Form.Item>
            </Modal>
        )
    }
}

export default Form.create()(AreaModifyModal)